import {
    SET_CUSTOMER_DATA,
    GET_LOCAL_DATA,
    SET_SHIPTO_DATA,
    SET_DEFAULTSC_DATA,
    SET_SC_DATA,
    SET_CART_DETAILS,
    SET_CART_ORDER_NUMBER,
    SET_ORDER_DATA,
    SET_ADMIN_DATA,
} from 'Actions/localData';
import {setProfile, loadProfile} from 'Utils/jwtUtil';

let initialState = {};

export function localData(state = initialState, action) {
    let payload = {};
    let profile = {};
    let item = {};

    switch (action.type) {
        case SET_CUSTOMER_DATA:
            payload = action.payload;
            profile = Object.assign({}, loadProfile()) || {};
            // profile = loadProfile() || {};

            if (payload && payload.data) {
                item = payload.data;
                let isChangeShipTo = false;
                if (item.type === 3 || item.type === 1) {
                    isChangeShipTo = true;
                }
                profile.customerEmail = item.email;
                profile.shipToNum = item.shipToNum;
                profile.blackFlag = item.blackFlag;
                profile.openId = item.openId;
                profile.roleType = item.type || 0;
                profile.name = item.name || item.lastName + item.firstName;
                profile.isAssociatedSc = item.isAssociatedSc;
                profile.fullAccountFlag = item.fullAccountFlag;
                profile.isProxyProcess = item.isProxyProcess;
                profile.labOrDept = item.labOrDept;
                profile.temporaryShipToNumber = isChangeShipTo
                    ? item.shipToNum
                    : typeof item.temporaryShipToNumber !== 'undefined'
                    ? item.temporaryShipToNumber
                    : typeof profile.temporaryShipToNumber === 'undefined' ||
                      profile.temporaryShipToNumber === ''
                    ? item.shipToNum
                    : profile.temporaryShipToNumber;
                profile.scId = item.scId;
                profile.scName = item.scName;
                profile.scType = item.scType;
                profile.cdcUid = item.cdcUid;
                if (typeof item.cdcUid !== 'undefined') {
                    window.tfsUserID = item.cdcUid;
                }
                setProfile(profile);
            }

            return {...state, ...profile};

        case SET_SHIPTO_DATA:
            payload = action.payload;
            profile = loadProfile() || {};

            if (payload) {
                profile.shipToNum =
                    typeof payload.temporaryShipToNumber !== 'undefined'
                        ? profile.shipToNum
                        : payload.shipToNum || payload.shipToNum;
                profile.shipToName = payload.stAddress + payload.stBuilding;
                profile.temporaryShipToNumber =
                    Object.prototype.toString.call(payload) ===
                    '[object String]'
                        ? payload
                        : payload.temporaryShipToNumber;
                setProfile(profile);
            }

            return {...state, ...profile};

        case SET_DEFAULTSC_DATA:
            payload = action.payload;
            profile = loadProfile() || {};
            if (payload) {
                profile.defaultScId = payload.supplyCenterId;
                profile.defaultScName = payload.supplyCenterName;
                profile.defaultScType = payload.type;
                profile.scId = profile.scId
                    ? profile.scId
                    : payload.supplyCenterId !== 0
                    ? payload.supplyCenterId
                    : null;
                // profile.scId = payload.id !== 0 ? payload.id : null;
                profile.scName = profile.scName
                    ? profile.scName
                    : payload.supplyCenterId !== 0
                    ? payload.supplyCenterName
                    : null;
                // profile.scName = payload.id !== 0 ? payload.name : null;
                profile.scType = profile.scType
                    ? profile.scType
                    : payload.supplyCenterId !== 0
                    ? payload.type
                    : null;
                setProfile(profile);
            }

            return {...state, ...profile};

        case SET_SC_DATA:
            payload = action.payload;
            profile = loadProfile() || {};
            if (payload) {
                profile.scId = payload.id;
                profile.scName = payload.name;
                profile.scType =
                    typeof payload.type !== 'undefined' ? payload.type : '';
                setProfile(profile);
            }

            return {...state, ...profile};

        case GET_LOCAL_DATA:
            profile = loadProfile() || {};

            return {...state, ...profile};

        case SET_ORDER_DATA:
            payload = action.payload;
            profile = loadProfile() || {};

            if (payload) {
                profile.orderId = payload.id;
                profile.orderNum = payload.number;
                setProfile(profile);
            }

            return {...state, ...profile};

        case SET_CART_DETAILS:
            payload = action.payload;
            profile = loadProfile() || {};

            if (payload) {
                profile.skuPrices = payload.skuPrices;
                profile.orderNumbers = payload.orderNumbers;
                // profile.scmOrderNumber = payload.scmOrderNumber;
                // profile.scmJobNumber = payload.scmJobNumber;
                // profile.tfsOrderNumber = payload.tfsOrderNumber;
                // profile.tfsJobNumber = payload.tfsJobNumber;
                profile.promoCodes = payload.promoCodes;
                profile.totalPrice = payload.totalPrice;
                profile.priceType = payload.priceType;
                setProfile(profile);
            }

            return {...state, ...profile};

        case SET_CART_ORDER_NUMBER:
            payload = action.payload;
            profile = loadProfile() || {};

            if (payload) {
                profile.orderNumbers = payload.orderNumbers;
                setProfile(profile);
            }

            return {...state, ...profile};

        case SET_ADMIN_DATA:
            payload = action.payload;
            profile = loadProfile() || {};

            if (payload && payload.data) {
                item = payload.data;
                profile.id = item.id;
                profile.email = item.email;
                profile.mobile = item.mobile;
                profile.blackFlag = item.blackFlag;
                profile.name = item.name;
                profile.roleType = item.type || item.roleType;
                profile.isProxyProcess = item.isProxyProcess || false;
                setProfile(profile);
            }

            return {...state, ...profile};

        default:
            return state;
    }
}
